import { Slider } from 'antd';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { explodedViewTool } from 'modules/common/viewer/cadViewer/data/actions';
import {
  getExplodedFactorForViewerId,
  getFocusedBodies,
  getIsExplodedViewActive,
} from 'modules/common/viewer/cadViewer/data/reducer';

const SliderWrapper = styled.div`
  width: 200px;
`;

const ExplodedViewSlider = ({
  isEnabled, // passed in as direct prop
}) => {
  const focusedBodies = useSelector(getFocusedBodies);
  const viewerId = focusedBodies[0];
  const factor = useSelector((state) =>
    getExplodedFactorForViewerId(state, viewerId),
  );
  const isExplodedViewActive = useSelector(getIsExplodedViewActive);
  const dispatch = useDispatch();
  const receiveExplodedState = useCallback(
    ({ assemblyInstanceId, factor }) => {
      dispatch(
        explodedViewTool.receiveExplodedState({ assemblyInstanceId, factor }),
      );
    },
    [dispatch],
  );
  const value = factor || 0.0;
  return isExplodedViewActive && isEnabled ? (
    <SliderWrapper>
      <Slider
        defaultValue={0.0}
        max={2.0}
        min={0.0}
        onChange={(val) =>
          receiveExplodedState({ assemblyInstanceId: viewerId, factor: val })
        }
        range={false}
        step={0.05}
        value={value}
      />
    </SliderWrapper>
  ) : null;
};

export default ExplodedViewSlider;
